import { CheckIcon, LinkIcon } from 'lucide-react'

import { Button, type ButtonProps } from '~/components/component-library'
import { useCopyValue } from '~/hooks/useCopyValue'

export const CopyLinkButton = ({
  trackingId,
  isDisabled,
  variant,
  link,
}: {
  trackingId: string
  isDisabled?: boolean
  variant?: ButtonProps['variant']
  link: string
}) => {
  const { isCopied, handleCopy } = useCopyValue()

  return (
    <Button
      variant={variant ?? 'tertiary'}
      onClick={() => handleCopy(link)}
      eventName="clickedCopyLink"
      eventProperties={{
        link,
        trackingId,
      }}
      prefix={isCopied ? <CheckIcon /> : <LinkIcon />}
      fullWidth
      isDisabled={isDisabled}
    >
      {isCopied ? 'Link copied' : 'Copy link to share'}
    </Button>
  )
}
